class ModalStickyHeader {
    constructor(modalBg) {
        this.modalBg = modalBg;
        this.stickyHeader = document.querySelector('[data-sticky-modal-header]');
        this.headerOffset = 0;
        this.getHeaderOffset();
        this.addEvents();
    }

    addEvents() {
        this.modalBg.addEventListener('scroll', (e) => {
            if (e.target.scrollTop > 100) {
                this.addSticky();
            } else {
                this.removeSticky();
            }
        });

        window.addEventListener('resize', () => {
            this.getHeaderOffset();
        });
    }

    addSticky() {
        this.stickyHeader.classList.add('_sticky');
        this.stickyHeader.style.top = `${this.modalBg.scrollTop - this.headerOffset}px`;
    }

    removeSticky() {
        this.stickyHeader.classList.remove('_sticky');
        this.stickyHeader.style.top = '0px';
    }

    getHeaderOffset() {
        const offset = window.getComputedStyle(this.modalBg).paddingTop;
        this.headerOffset = parseInt(offset);
    }
}

document.addEventListener('modal:open', () => {
    const modalBg = document.querySelector('.modal__bg._technology');
    if (!modalBg) {
        return;
    }

    new ModalStickyHeader(modalBg);
});